// extracted by mini-css-extract-plugin
module.exports = {"btn":"ReviewMerchant_btn__1phao","btnDefault":"ReviewMerchant_btnDefault__2CWge"};